export class CaretPositionHelper {
    static createStyledDiv(target, htmlContent) {
        const div = document.createElement('div');
        const styles = {
            position: 'absolute',
            left: -9999,
            top: 0,
            zIndex: -2000
        };
        this.properties.forEach((prop) => {
            styles[`${prop}`] = getComputedStyle(target)[prop];
        });
        Object.keys(styles).forEach((key) => {
            div.style[`${key}`] = styles[`${key}`];
        });
        const scrollbarWidth = target.offsetWidth - target.clientWidth;
        div.style.width = (target.clientWidth + scrollbarWidth) + 'px';
        div.innerHTML = htmlContent;
        if (target && target.parentNode) {
            target.parentNode.insertBefore(div, target.nextSibling);
        }
        return div;
    }
    static createCaretMarker(target, htmlContent) {
        const div = this.createStyledDiv(target, htmlContent);
        const marker = div.ownerDocument.getElementById('caret-position-marker');
        const position = {
            left: marker.offsetLeft,
            top: marker.offsetTop,
            height: marker.offsetHeight
        };
        if (div && div.parentNode) {
            div.parentNode.removeChild(div);
        }
        return position;
    }
    static escapeHtml(value) {
        return value.replace(/<|>|`|"|&/g, '?').replace(/\r\n|\r|\n/g, '<br/>');
    }
    static getCaretPosition(target) {
        const position = target.selectionStart || 0;
        const textBeforeCaret = target.value.slice(0, position);
        const textAfterCaret = target.value.slice(position);
        let content = `<span style="position: relative; display: inline;">${this.escapeHtml(textBeforeCaret)}</span>`;
        content += '<span id="caret-position-marker" style="position: relative; display: inline;">|</span>';
        content += `<span style="position: relative; display: inline;">${this.escapeHtml(textAfterCaret)}</span>`;
        const rect = this.createCaretMarker(target, content);
        rect.pos = position;
        return rect;
    }
    static adjustScrollToCaretPosition(element) {
        const caretPosition = this.getCaretPosition(element);
        const lineHeight = parseFloat(window.getComputedStyle(element).lineHeight);
        if (caretPosition.top > element.clientHeight + element.scrollTop - lineHeight) {
            element.scrollTop = caretPosition.top - element.clientHeight + lineHeight;
        }
    }
    static getTextAreaPosition(element) {
        const computedStyle = window.getComputedStyle(element);
        const position = this.getCaretPosition(element);
        return {
            top: position.top + parseFloat(computedStyle.borderTopWidth) + element.offsetTop - element.scrollTop,
            left: position.left + parseFloat(computedStyle.borderLeftWidth) + element.offsetLeft - element.scrollLeft - 0.25,
            height: position.height,
            elemStyle: computedStyle
        };
    }
    static insertCharacter(element, text) {
        let start = element.selectionStart;
        const end = element.selectionEnd;
        element.value = element.value.substring(0, start) + text + element.value.substring(end);
        start += text.length;
        element.setSelectionRange(start, start);
    }
}
CaretPositionHelper.properties = [
    'borderBottomWidth', 'borderLeftWidth', 'borderRightWidth', 'borderTopStyle',
    'borderRightStyle', 'borderBottomStyle', 'borderLeftStyle', 'borderTopWidth',
    'boxSizing', 'fontFamily', 'fontSize', 'fontWeight', 'height', 'letterSpacing',
    'lineHeight', 'marginBottom', 'marginLeft', 'marginRight', 'marginTop',
    'outlineWidth', 'overflow', 'overflowX', 'overflowY', 'paddingBottom',
    'paddingLeft', 'paddingRight', 'paddingTop', 'textAlign', 'textOverflow',
    'textTransform', 'whiteSpace', 'wordBreak', 'wordWrap', 'width'
];
